<template>
  <div class="item">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="header-content">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资质信誉</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="title">
        <span v-for="(item,index) in title" :key="index" :class="{ active : CurrentId == index }"
              @click="ChangeId(index,item.code)"
        >{{item.name}}</span>
      </div>
      <div class="content-base">
        <qua-image :img-list="ContentList"></qua-image>
      </div>
    </div>
    <el-pagination
      background
      class="page"
      :page-size="1"
      style="margin:25px; text-align: center"
      @current-change="handleCurrentChange"
      :total="Cpage"
      layout="prev, pager, next"
    > </el-pagination>
  </div>
</template>

<script>
  import QuaImage from "./QuaImage";
  export default {
    name: "QualityEnter",
    components: {QuaImage},
    data(){
      return{
        title:null,
        CurrentId:0,
        Cpage:null,
        ContentList:null,
        Data:{
          'pageSize':15,
          'pageNumber':0,
          'type':1,
        }
      }
    },
    created() {
      this.GetTypeList()
      this.GetData(this.Data)
    },
    methods:{
      handleCurrentChange(index){
        this.Data.pageNumber=index
        this.GetData(this.Data)
      },
      ChangeId(index,code){
        this.CurrentId=index;
        this.Data.type=code
        this.GetData(this.Data)
      },
      GetData(data){
        this.$axios.post('/api/certification/getList',data).then(res=>{

          this.ContentList=res.data.data.records
          this.Cpage=res.data.data.pages
        })
      },
      GetTypeList(){
        this.$axios.get('/api/certification/getTypeList').then(res=>{
          this.title=res.data.data;
        })
      }
    }
  }
</script>

<style lang="less" scoped>
.active{
    color: #ffffff;
    height: 35px;
    background: #188ACB;
    border-radius: 20px;
    padding: 8.5px 15px;
  }
.header{
  height: 44px;
  background: #F6F7F8;
  .header-content{
    line-height: 44px;
    margin: 0 auto;
    width: 74.5%;
    /*padding:10px;*/
  }
}
.content-base{
  padding-top: 40px;
}
.content{
  margin: 0 auto;
  width: 74.5%;
  min-height: 81vh;
  .title{
    text-align: center;
    margin: 30px 0;
    span{
      height: 18px;
      font-size: 18px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      line-height: 27px;
      margin: 0 10px;
    }
  }
}
</style>